import { render, staticRenderFns } from "./OrderPaymentInformation.vue?vue&type=template&id=a52544a6"
import script from "./OrderPaymentInformation.vue?vue&type=script&lang=js"
export * from "./OrderPaymentInformation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports